import { fetchSummary } from "../../resources/DashboardResource";
import React, { useEffect, useState } from "react";

export default function SummaryDashboard() {
    const [dataSummary, setDataSummary] = useState({});

    const fetchDataSummary = () => {
        fetchSummary()
            .then((res) => {
                setDataSummary(res.data);
            })
            .catch((err) => {
                setDataSummary({});
            });
    };

    useEffect(() => {
        fetchDataSummary();
    }, []);

    return (<div className="row">
        <div className="col-12 col-lg-3">
            <div className="card radius-15 bg-rose">
                <div className="card-body">
                    <div className="d-flex align-items-center">
                        <div>
                            <h1 className="mb-0 text-white">{ dataSummary.out }</h1>
                        </div>
                        <div className="ms-auto font-35 text-white">
                            <i className="bx bx-line-chart-down"></i>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div>
                            <p className="mb-0 text-white">Part OUT Today</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-12 col-lg-3">
            <div className="card radius-15 bg-success">
                <div className="card-body">
                    <div className="d-flex align-items-center">
                        <div>
                            <h1 className="mb-0 text-white">{ dataSummary.in }</h1>
                        </div>
                        <div className="ms-auto font-35 text-white">
                            <i className="bx bx-package"></i>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div>
                            <p className="mb-0 text-white">Part IN Today </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-12 col-lg-3">
            <div className="card radius-15 bg-sunset">
                <div className="card-body">
                    <div className="d-flex align-items-center">
                        <div>
                            <h1 className="mb-0 text-white">{ dataSummary.onRequest }</h1>
                        </div>
                        <div className="ms-auto font-35 text-white">
                            <i className="bx bx-list-check"></i>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div>
                            <p className="mb-0 text-white">Part ON REQUEST</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-12 col-lg-3">
            <div className="card radius-15 bg-danger">
                <div className="card-body">
                    <div className="d-flex align-items-center">
                        <div>
                            <h1 className="mb-0 text-white">{ dataSummary.underStock }</h1>
                        </div>
                        <div className="ms-auto font-35 text-white">
                            <i className="bx bx-bell"></i>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div>
                            <p className="mb-0 text-white">Understock</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>);
}